import axios from "axios";
import I18n from "../../../i18n/setup.js.erb";
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    step: String,
    amountEur: Number,
    defiscOption: String,
    modulableWaitingList: Boolean,
    minAmountEur: Number,
  }
  static targets = [
    "title", 
    "submitAmountBtn", 
    "submitDefiscOptionBtn",
    "amountInput",
    "documentsReadInput",
    "amountErrorMessage",
    "abortBtn",
    "submitSubscriptionBtn",
    "subscriptionCreateErrorMessage",
    "modulableWithMinimumContainer",
    "submitWaitingListOptionsBtn",
  ]

  initialize() {
    this.steps = JSON.parse(this.element.dataset.steps)
    this.documentsListSize = JSON.parse(this.element.dataset.documentsListSize)
    this.createSubscriptionUrl = this.element.dataset.createSubscriptionUrl
    this.validateAmountUrl  = this.element.dataset.validateAmountUrl
    this.tokenId = this.element.dataset.tokenId
    this.externalSignature = false
    this.displayStep()
    this.handleAmountInput({target: this.amountInputTarget})
    this.toggleDocumentsRead({target: this.documentsReadInputTarget})
  }

  handleAmountInput(e) {
    this.amountEurValue = e.target.value
    if (this.amountEurValue) {
      this.handleAmountDependentElements()
      this.submitAmountBtnTarget.classList.remove("btn-disabled")
    } else {
      this.submitAmountBtnTarget.classList.add("btn-disabled")
    }
  }

  submitAmount() {
    this.submitAmountBtnTarget.classList.add("btn-disabled")
    this.amountErrorMessageTarget.classList.add("d-none")
    const params = [["token_id", this.tokenId], ["project_subscription[amount_eur]", this.amountInputTarget.value]]
    const validateTokenParams = params.map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`).join('&');
    axios.get(this.validateAmountUrl + "/?" + validateTokenParams, {headers: {"Accept": "application/json"}, withCredentials: true}).then(res => {
      if (res.status == 200) {
        if (res.data.success) {
          this.submitAmountBtnTarget.classList.remove("btn-disabled")
          this.amountEurValue = this.amountInputTarget.value
          this.externalSignature = res.data.external_signature
          this.handleAmountDependentElements()
          this.nextStep()
        } else {
          this.abortBtnTarget.classList.remove("d-none")
          this.amountInputTarget.classList.add("is-invalid")
          this.amountErrorMessageTarget.classList.remove("d-none")
          this.amountErrorMessageTarget.textContent = res.data.error == 'max_exceeded' ? I18n.t("subscriptions.errors.max_exceeded", {max_amount: res.data.max_invest}) : res.data.message
        }
      }
    })
  }
  updateStep(e) {
    this.stepValue = e.target.dataset.stepValue
    this.displayStep()
  }
  nextStep() {
    // Optional documents step -> no need if not external signature and only 1 document to check
    if (this.documentsListSize <= 1 && !this.externalSignature) {
      this.steps = this.steps.filter(step => step != "documents_read")
    }
    const nextIndex = this.steps.indexOf(this.stepValue) + 1
    if (this.steps.length > nextIndex) {
      this.stepValue = this.steps[nextIndex]
      this.displayStep()
    } else {
      this.createSubscription()
    }
  }
  handleAmountDependentElements() {
    const defiscOptionAmountElements = document.querySelectorAll(".defisc-option-change-amount")
    defiscOptionAmountElements.forEach(element => {
      if (element.dataset.checkMinAmount == "true" && parseInt(this.amountEurValue) <  parseInt(element.dataset.minAmount)) {
        element.querySelector("input").classList.add("d-none")
        element.querySelector(".alert-warning").classList.remove("d-none")
      } else {
        element.querySelector("input").classList.remove("d-none")
        element.querySelector(".alert-warning").classList.add("d-none")
      }
    })
  }

  chooseDefiscOption(e) {
    const defiscOption = e.target.closest(".defisc-option-wrapper").dataset.defiscOption
    if (!document.querySelector(`#defisc-option-choice-${defiscOption}`).classList.contains("d-none")) {
      this.defiscOptionValue  = defiscOption == "null" ? '' : defiscOption
      document.querySelectorAll(".defisc-option-choice").forEach(option => {
       if (option.dataset.defiscOption ==  defiscOption) {
         option.checked = true
         } else {
           option.checked = false
         }
       })
       document.querySelectorAll(".defisc-option-alerts").forEach(alert => alert.classList.add("d-none"))
       document.querySelector("#defisc-option-alert-" + e.target.dataset.defiscOption)?.classList?.remove("d-none")
    } 

  }

  displayStep() {
    document.querySelectorAll('.subscription-step').forEach(step => {
      step.classList.add('d-none')
      if(step.dataset.step == this.stepValue) { 
        step.classList.remove("d-none") 
        this.titleTarget.textContent = I18n.t("subscriptions.steps." + this.stepValue + ".title")
      }
    })
  }

  toggleDocumentsRead(e) {
    if (e.target.checked) {
      this.submitSubscriptionBtnTarget.classList.remove("btn-disabled")
    } else {
      this.submitSubscriptionBtnTarget.classList.add("btn-disabled")
    }
  }

  createSubscription(e) {

    this.submitSubscriptionBtnTarget.classList.add("btn-disabled")
    const csrf_token = document.querySelector('meta[name="csrf-token"]')
    const postOptions = {
      headers: {
        "Accept": "application/json",
        'X-CSRF-Token': csrf_token ? csrf_token.getAttribute('content') : null
      }
    }
    const postData = {
      token_id: this.tokenId,
      project_subscription: {
        amount_eur: this.amountEurValue,
        defisc_option: this.defiscOptionValue,
        modulable_waiting_list: this.modulableWaitingListValue,
        min_amount_eur: this.modulableWaitingListValue ? this.minAmountEurValue : 0,
      }
    }
    axios.post(this.createSubscriptionUrl, postData, postOptions).then(res => {
      this.submitSubscriptionBtnTarget.classList.remove("btn-disabled")
      if (res.data.success) {
        window.location.href = res.data.redirect_url
      } else {
        res.data.messages.forEach((error) => {
          document.querySelectorAll(".subscription-create-error-message").forEach((el) => {
            el.insertAdjacentHTML("beforeend", `<div>${error}</div>`)
          })
        })
      }
    })
  }

  selectWaitingListOption(e) {
    const wrapperElement = e.target.closest(".waiting-list-option-wrapper")
    const selectedOption = wrapperElement.dataset.option
    wrapperElement.querySelector("input").click()
    switch(selectedOption) {
    case "modulable_with_min":
      this.modulableWithMinimumContainerTarget.classList.remove("d-none")
      this.modulableWaitingListValue = true
      break;
    case "modulable_without_min":
      this.modulableWithMinimumContainerTarget.classList.add("d-none")
      this.submitWaitingListOptionsBtnTarget.classList.remove("btn-disabled")
      this.modulableWaitingListValue = true
      this.minAmountEurValue = 0
      break;
    default:
      this.modulableWithMinimumContainerTarget.classList.add("d-none")
      this.submitWaitingListOptionsBtnTarget.classList.remove("btn-disabled")
      this.modulableWaitingListValue = false
      this.minAmountEurValue = 0
    }
  }
      
  updateMinimumInvestment(e) {
    this.minAmountEurValue = parseInt(e.target.value)
    this.submitWaitingListOptionsBtnTarget.classList.remove("btn-disabled")
  }
}


